var map = {
	"./img_2.jpg": 50902,
	"./img_3.jpg": 15553,
	"./img_4.jpg": 80843,
	"./img_5.jpg": 20428,
	"./img_6.jpg": 45370,
	"./img_7.jpg": 49042,
	"./img_8.jpg": 99148,
	"./img_9.jpg": 24563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18285;